import React from "react";

const SearchPage = () => {
  return (
    <div className="max-w-4xl mx-auto mt-8">
      <h1 className="text-3xl font-bold mb-4">Search Results</h1>
      {/* Display search results here */}
    </div>
  );
};

export default SearchPage;
